import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { filter, takeUntil } from 'rxjs/operators';
import scrollIntoView from 'scroll-into-view-if-needed';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { SessionService } from '../../../common/services/Session.service';
import { LoginService } from '../../../common/services/Login.service';

@Component({
  selector: 'app-archive-page-viewer',
  templateUrl: './archive-page-viewer.component.html',
  styleUrls: ['./archive-page-viewer.component.css']
})
export class ArchivePageViewerComponent implements OnInit, OnDestroy {

  title;
  body;
  publicationId
  pageId;
  paragraphs: string[];
  paragraphContent = [];
  paragraphNum: string[] = [];
  pageHeading;
  paragraphIdsList: any[] = [];
  paraArticleId: string = "";
  addedparagraphList = [];
  event$
  pageUrl: string = "";
  archivePage: boolean = true;
  version: string = "";
  versionDate: string = "";
  breadcrumbNum: string = "";
  focusParaId: string;

  @Input() RightOverlay: boolean;
  @Input() RightOverlayPageID: any;
  @Input() ParaID: string;
  s3ImageBasePath: string = "";
  displayAllSourcesValue: any;

  @Output() myEvent = new EventEmitter<string>();
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private commonDataService: CommonDataService, private session: SessionService, private loginService: LoginService,
    private graphQLService: GraphqlService, private router: Router, private sanitizer: DomSanitizer) {
    this.getUserId();
    this.publicationId = this.router.url.split("/")[2];
    this.pageId = this.router.url.split("/")[3];
  }
  verisonGuid: string = "";
  topic_subtopicNum: string;
  s3BucketPathCall: Subscription;
  getBreadcrumbSessionCall: Subscription;
  ngOnInit(): void {
    // localStorage.setItem("isArchivePage","true");
    this.paragraphTitleContent = [];
    this.paragraphContent = [];
    this.focusParaId = this.ParaID;

    this.commonDataService.showLoader.next(true);
    this.archivePage = true;
    if (this.RightOverlay) {
      this.s3BucketPathCall = this.graphQLService.getS3BucketImagePath().subscribe(data => { this.s3ImageBasePath = data; });
      // this.getPageContent("94389","2147483606");
      // this.getPageContent(this.RightOverlayPageID[0], this.RightOverlayPageID[1], this.RightOverlayPageID[2]);
      this.getBreadcrumbSessionCall = this.graphQLService.GetBreadcrumbSession(this.RightOverlayPageID.pubId + "/" + this.RightOverlayPageID.pageId).subscribe(breadcrumbData => {
        if (breadcrumbData !== null) {
          this.navData = JSON.parse(JSON.stringify(breadcrumbData));
          if (this.navData.crumbData != null) {
            this.topic_subtopicNum = "";
            for (let i = 1; i <= this.navData.crumbData.length - 2; i++) {
              if (this.navData.crumbData[i].split(" ")[0] != '' && !(this.navData.crumbData[i].split(" ")[0]).includes("X")) {
                this.topic_subtopicNum += this.navData.crumbData[i].split(" ")[0] + "-";
              }
            }
          }
          this.getPageContent(this.RightOverlayPageID.pubId, this.RightOverlayPageID.pageId, this.navData.crumbData[this.navData.crumbData.length - 1]);
        }
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
      //this.getBreadCrumb();
    } else {

      this.archiveCall = forkJoin(this.graphQLService.getS3BucketImagePath(), this.graphQLService.GetArchiveLabels(), this.graphQLService.getArchivePageData(this.publicationId, this.pageId), this.graphQLService.getArchiveDetails(this.publicationId, this.pageId))
        .subscribe(([s3Data, labels, archiveData, archiveDetails]) => {
          this.s3ImageBasePath = s3Data;
          this.archiveLabels = labels;
          this.version = archiveDetails.revision;
          this.verisonGuid = archiveDetails.guid;
          this.versionDate = archiveDetails.expiryDate;
          this.topicBodyContent = [];
          this.title = archiveData.contentPageTitle;
          this.getCrumbData(archiveDetails.guid);
          this.getParagraphs(archiveData);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
    }
    this.event$
      = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.publicationId = this.router.url.split("/")[2];
          this.pageId = this.router.url.split("/")[3];
          this.archiveCall = forkJoin(this.graphQLService.getArchivePageData(this.publicationId, this.pageId), this.graphQLService.getArchiveDetails(this.publicationId, this.pageId))
            .subscribe(([archiveData, archiveDetails]) => {
              this.version = archiveDetails.revision;
              this.verisonGuid = archiveDetails.guid;
              this.versionDate = archiveDetails.expiryDate;
              this.topicBodyContent = [];
              this.title = archiveData.contentPageTitle;
              this.getCrumbData(archiveDetails.guid);
              this.getParagraphs(archiveData);
            }, err => {
              console.log(err);
              this.commonDataService.showLoader.next(false);
            });
        });

    this.commonDataService.displayAllSources.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.displayAllSourcesValue = data;
      if (data != null) {
        let sfragment = document.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
        if (sfragment && sfragment?.length) {
          let sfragmentDataStringNew = "";
          for (let i = 0; i < sfragment?.length; i++) {
            let sfragmentData1 = sfragment[i].getElementsByClassName('sfragment-data');
            for (let j = 0; j < sfragmentData1?.length; j++) {
              let standardName = sfragmentData1[j].getElementsByClassName('sfragment-standard-name');
              let standardNumber = sfragmentData1[j].getElementsByClassName('sfragment-standard-number');
              let paraNumber = sfragmentData1[j].getElementsByClassName('sfragment-para-number');

              if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
                sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
              }
              if (paraNumber && paraNumber?.length) {
                sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
              }
              if (sfragmentDataStringNew != "") {
                sfragmentData1[j].innerHTML = sfragmentDataStringNew;
              }
              sfragmentDataStringNew = "";
            }
          }
        }
        let sfragmentData = document.getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;
        if (data.toggleValue.toString() == "true") {
          for (let i = 0; i < sfragment.length; i++) {
            sfragment[i].classList.add('show-sources-sfragment');
          }
          for (let i = 0; i < sfragmentData.length; i++) {
            sfragmentData[i].classList.add('show-sources-sfragment-data');
            sfragmentData[i].style.display = 'inline';
          }
        }
        else {
          for (let i = 0; i < sfragment.length; i++) {
            sfragment[i].classList.remove('show-sources-sfragment');
          }
          for (let i = 0; i < sfragmentData.length; i++) {
            sfragmentData[i].classList.remove('show-sources-sfragment-data');
            sfragmentData[i].style.display = 'none';
          }
        }
      }
    });

    this.commonDataService.displayAllSourcesForPrint.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        let article = document.getElementById("printPara");
        if (article != null) {
          let sfragment = article.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
          if (sfragment && sfragment?.length) {
            let sfragmentDataStringNew = "";
            for (let i = 0; i < sfragment?.length; i++) {
              let sfragmentData2 = sfragment[i].getElementsByClassName('sfragment-data');
              for (let j = 0; j < sfragmentData2?.length; j++) {
                let standardName = sfragmentData2[j].getElementsByClassName('sfragment-standard-name');
                let standardNumber = sfragmentData2[j].getElementsByClassName('sfragment-standard-number');
                let paraNumber = sfragmentData2[j].getElementsByClassName('sfragment-para-number');

                if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
                  sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
                }
                if (paraNumber && paraNumber?.length) {
                  sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
                }
                if (sfragmentDataStringNew != "") {
                  sfragmentData2[j].innerHTML = sfragmentDataStringNew;
                }
                sfragmentDataStringNew = "";
              }
            }
          }
          let sfragmentData = article.getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;

          if (data.toggleValue) {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.add('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.add('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'inline';
            }
          }
          else {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.remove('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.remove('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'none';
            }
          }
        }
      }
    });
  }

  formatSources(data: any) {
    let sfragment = document.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
    if (sfragment && sfragment?.length) {
      for (let i = 0; i < sfragment?.length; i++) {
        if (!sfragment[i].classList.contains("formatted")) {
          let sfragmentData = sfragment[i].getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;
          for (let j = 0; j < sfragmentData?.length; j++) {

            let sfragmentDataStringNew = "";
            let standardName = sfragmentData[j].getElementsByClassName('sfragment-standard-name');
            let standardNumber = sfragmentData[j].getElementsByClassName('sfragment-standard-number');
            let paraNumber = sfragmentData[j].getElementsByClassName('sfragment-para-number');

            if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
              sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
            }
            if (paraNumber && paraNumber?.length) {
              sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
            }
            if (sfragmentDataStringNew != "") {
              sfragmentData[j].innerHTML = sfragmentDataStringNew;
            }
            if (data.toggleValue.toString() == "true") {
              sfragmentData[j].classList.add('show-sources-sfragment-data');
              sfragmentData[j].style.display = 'inline';
            }
            else {
              sfragmentData[j].classList.remove('show-sources-sfragment-data');
              sfragmentData[j].style.display = 'none';
            }
          }
          if (data.toggleValue.toString() == "true") {
            sfragment[i].classList.add('show-sources-sfragment');
          }
          else {
            sfragment[i].classList.remove('show-sources-sfragment');
          }
          sfragment[i].classList.add('formatted');
        }
      }
    }
  }

  archiveLabels;
  ngOnDestroy(): void {
    if (this.s3BucketPathCall != undefined && this.s3BucketPathCall != null) {
      this.s3BucketPathCall.unsubscribe();
    }

    if (this.getBreadcrumbSessionCall != undefined && this.getBreadcrumbSessionCall != null) {
      this.getBreadcrumbSessionCall.unsubscribe();
    }

    if (this.event$ != undefined && this.event$ != null) {
      this.event$.unsubscribe();
    }

    if (this.sessionCall != undefined && this.sessionCall != null) {
      this.sessionCall.unsubscribe();
    }

    if (this.pageDataCall != undefined && this.pageDataCall != null) {
      this.pageDataCall.unsubscribe();
    }

    if (this.archiveCall != undefined && this.archiveCall != null) {
      this.archiveCall.unsubscribe();
    }
    if (this.destroy$) {
      this.destroy$.next();
      this.destroy$.complete();
    }
    localStorage.removeItem("isArchivePage");
  }

  loggedInUserInfo: any;
  sessionCall: Subscription;
  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo?.user?.roles == null) {
      this.sessionCall = this.loginService.getSession().subscribe(data => {
        this.loggedInUserInfo = data;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.loggedInUserInfo = this.session.userInfo;
    }
  }

  @HostListener('window:click', ['$event'])
  onClick(e: any) {
    const path = e.composedPath() as Array<any>;
    e.preventDefault();
    const firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      this.myEvent.emit();
    }
  }

  ngAfterViewChecked(): void {
    if (this.focusParaId && this.focusParaId != "") {
      let el = document.getElementById(this.topic_subtopicNum + this.ParaID);
      if (el) {
        // el.scrollIntoView();
        scrollIntoView(el, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
        this.focusParaId = "";
      }
    }
    if (this.displayAllSourcesValue != null) {
      this.formatSources(this.displayAllSourcesValue)
    }
  }

  archive_back: string = "";
  archive_version: string = "";
  archive_asOf: string = "";
  archiveCall: Subscription;
  getArchiveLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.archive_asOf = labels.filter(x => x.key == "archive_asOf").map(y => y.value);
      this.archive_back = labels.filter(x => x.key == "archive_back").map(y => y.value);
      this.archive_version = labels.filter(x => x.key == "archive_version").map(y => y.value);
      this.archive_back = this.archive_back[0].replace("[PAGE]", this.breadcrumbNum);
      this.topic_subtopicNum = this.breadcrumbNum.split("-")[0] + "-" + this.breadcrumbNum.split("-")[1] + "-";
    }
  }

  topicBodyContent: any = [];
  apiResponse: any;
  pageDataCall: Subscription;
  getPageContent(publicationId: string, pageId: string, pageName: string) {
    var pageHeader = {"publicationId": publicationId, "pageId": pageId, "pageName": pageName, "pageNavPath": "", "PendingContentIntegrationData": [] };
    this.pageDataCall = this.graphQLService.getPageData(pageHeader).subscribe((result) => {
      this.topicBodyContent = [];
      this.apiResponse = result;
      this.pageInfoMapping(this.apiResponse);
      this.title = this.apiResponse.contentPageTitle;
      this.getParagraphs(this.apiResponse);
    }, err => {
      console.log(err);
    });
  }

  navData;

  pageInfoMapping(data) {
    this.topicBodyContent = [];
    data.contentPageInfo.forEach(info => {
      let obj = {
        PageInfoPosition: info.infoPosition,
        contentPageTitle: info.contentPageTitle,
        contentPageBody: this.sanitizer.bypassSecurityTrustHtml(info.contentPageBody)
      }
      this.topicBodyContent.push(obj);
    });
  }

  getCrumbData(guid) {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = leftNavigation.length - 1; i >= 0; i--) {
      this.breadcrumbNum = "";
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j].itemData != null) {
            for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
              if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData[l].archiveListGuids != null) {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData[l].archiveListGuids?.includes(guid)) {
                      this.breadcrumbNum += leftNavigation[i].itemData[j].item.split(" ")[0];
                      this.breadcrumbNum += "-"+leftNavigation[i].itemData[j].itemData[k].item.split(" ")[0];
                      this.breadcrumbNum += "-"+leftNavigation[i].itemData[j].itemData[k].itemData[l].item.split(" ")[0];
                      this.pageUrl = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink;
                      this.getArchiveLabel(this.archiveLabels);
                      return;
                    }
                  }
                  else {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                      for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].archiveListGuids?.includes(guid)) {
                          this.breadcrumbNum = leftNavigation[i].itemData[j].item.split(" ")[0];
                          this.breadcrumbNum += "-" +leftNavigation[i].itemData[j].itemData[k].item.split(" ")[0];
                          this.breadcrumbNum += "-" +leftNavigation[i].itemData[j].itemData[k].itemData[l].item.split(" ")[0];
                          this.breadcrumbNum += "-" +leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item.split(" ")[0];
                          this.pageUrl = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink;
                          this.getArchiveLabel(this.archiveLabels);
                          return;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return;
  }

  paragraphTitleContent: any[] = [];
  paraGroups: any[] = [];
  pgroups = [];
  pgroup;
  pgroupName: string = "";
  TopicTitle: string[];
  topicheader: string;
  TopicBody: string[];
  paragraph: string[];
  topicheader2: string;
  outcome: boolean = false;
  paraBody: string[] = [];
  paragraphArrayIds: string[] = [];
  annotationCountDictionary: string[] = [];
  bookmarkCountDictionary: string[] = [];
  getParagraphs(response) {
    this.paragraphContent = [];
    this.paragraphTitleContent = [];
    if (response.paraGroups != undefined) {
      for (let l = 0; l < response.paraGroups.length; l++) {
        this.paragraphContent = [];
        for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
          for (var i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
            if (i == 0) {
              let temp = {
                paragroup: response.paraGroups[l].pgroups[k].pgroupName,
                id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
                paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
                paraAnnotationCount: 0,
                paraBookmarkCount: 0,
                paraTitle: [response.paraGroups[l].pgroups[k].paraBodyTitle[i], response.paraGroups[l].pgroups[k].paraBodyTitle2[i], response.paraGroups[l].pgroups[k].paraBodyTitle3[i], response.paraGroups[l].pgroups[k].paraBodyTitle4[i], response.paraGroups[l].pgroups[k].paraBodyTitle5[i]],
                paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
                PrintQueueAdded: false,
                actionLabel: []
              }
              this.paragraphContent.push(temp);
            }
            else {
              let temp = {
                paragroup: "",
                id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
                paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
                paraAnnotationCount: 0,
                paraBookmarkCount: 0,
                paraTitle: [response.paraGroups[l].pgroups[k].paraBodyTitle[i], response.paraGroups[l].pgroups[k].paraBodyTitle2[i], response.paraGroups[l].pgroups[k].paraBodyTitle3[i], response.paraGroups[l].pgroups[k].paraBodyTitle4[i], response.paraGroups[l].pgroups[k].paraBodyTitle5[i]],
                paraContent: response.paraGroups[l].pgroups[k].paraBody[i],
                PrintQueueAdded: false,
                actionLabel: []
              }
              this.paragraphContent.push(temp);
            }
          }
        }
        this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: this.paragraphContent });
      }
    }
    this.outcome = true;
    this.commonDataService.showLoader.next(false);
    this.pageHeading = this.title;
  }

  BackToCurrentVersion() {
    localStorage.removeItem("isArchivePage");
    this.router.navigateByUrl(this.pageUrl);
  }
}
